/**
 * NewspaperIcon — sanitized from `assets/newSvg/newspaper.svg`.
 * Artboard: 1024×1024 · viewBox 0 0 24 24 (fixed).
 */
import React from 'react';
import Svg, { Path } from 'react-native-svg';
import {
  APP_ICON_VIEW_BOX,
  useAppIconProps,
  type AppIconProps,
} from './iconBase';

export function NewspaperIcon(props: AppIconProps) {
  const { size, color, style, accessibilityLabel, testID, ...rest } = useAppIconProps(props);

  return (
    <Svg
      width={size}
      height={size}
      viewBox={APP_ICON_VIEW_BOX}
      style={style}
      accessibilityLabel={accessibilityLabel}
      testID={testID}
      {...rest}
    >
      <Path
        d="M18.7175,18.7176 C20.4748,16.9603 20.4748,14.111 18.7175,12.3537 L11.6464,5.2826 C11.0606,4.69681 11.0606,3.74706 11.6464,3.16128 C12.2322,2.57549 13.1819,2.57549 13.7677,3.16128 L20.8388,10.2323 C23.7677,13.1613 23.7677,17.91 20.8388,20.8389 C17.9099,23.7679 13.1611,23.7679 10.2322,20.8389 L1.74691,12.3537 C-0.400977,10.2058 -0.400977,6.72337 1.74691,4.57549 C3.89479,2.42761 7.3772,2.42761 9.52508,4.57549 L17.6568,12.7072 C19.0236,14.0741 19.0236,16.2901 17.6568,17.657 C16.29,19.0238 14.0739,19.0238 12.7071,17.657 L5.28244,10.2323 C4.69665,9.64656 4.69665,8.69681 5.28244,8.11102 C5.86823,7.52524 6.81797,7.52524 7.40376,8.11102 L14.8284,15.5356 C15.0236,15.7309 15.3402,15.7309 15.5355,15.5356 C15.7308,15.3404 15.7308,15.0238 15.5355,14.8285 L7.40376,6.69681 C6.42745,5.7205 4.84454,5.7205 3.86823,6.69681 C2.89192,7.67312 2.89192,9.25603 3.86823,10.2323 L12.3535,18.7176 C14.1109,20.475 16.9601,20.475 18.7175,18.7176 Z"
        fill={color}
      />
    </Svg>
  );
}

export default NewspaperIcon;
